document.addEventListener("DOMContentLoaded", (event) => {
    
  });
window.addEventListener("load", (event) => {
  var str = $('.jdgm-rev-widg__summary-average').text();
var test = str.split(" out");
$('.jdgm-rev-widg__summary-average').addClass('active');
$('.jdgm-rev-widg__summary-average').text(test[0]);
$('.jdgm-rev-widg[data-number-of-reviews="0"] .jdgm-rev-widg__body').text('Be the first to write a review for this product.');
$('.jdgm-rev-widg[data-number-of-reviews="0"]').addClass('empty');
});
$(document).ready(function(){
  setTimeout(function(){
    var str = $('.jdgm-rev-widg__summary-average').text();
  var test = str.split(" out");
  $('.jdgm-rev-widg__summary-average').addClass('active');
  $('.jdgm-rev-widg__summary-average').text(test[0]);
  $('.jdgm-rev-widg[data-number-of-reviews="0"] .jdgm-rev-widg__body').text('Be the first to write a review for this product.');
  $('.jdgm-rev-widg[data-number-of-reviews="0"]').addClass('empty');
  },1000);
  var width=$('body').width();
  $('.open-menu').click(function(){
    $(this).toggleClass('active');
    $('.main-menu').toggleClass('open');
    $('body').toggleClass('open');
  });
  $(document).mouseup( function(e){
    var div = $( ".main-menu .page-width" );
    if ( !div.is(e.target) && div.has(e.target).length === 0 ) {
      $('.open-menu').removeClass('active');
      $('.main-menu').removeClass('open');
      $('body').removeClass('open');
    }
  });
  $(document).mouseup( function(e){
    var div = $( ".mobile-facets__inner" );
    var div2 = $( ".mobile-facets__open-wrapper" );
    if ( !div.is(e.target) && div.has(e.target).length === 0 ) {
    if ( !div2.is(e.target) && div2.has(e.target).length === 0 ) {
      div.closest('details').attr('open',false);
      div.closest('details').removeClass('menu-opening');
    }}
  });
  $('.top-b .close').click(function(){
    $('.open-menu').removeClass('active');
      $('.main-menu').removeClass('open');
      $('body').removeClass('open');
  })
  $('.top-b .back').click(function(){
    $(this).closest('details').attr('open',false);
  });
  $('.tabs .tab-head a').click(function(){
    $('.tabs .tab-head a').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.tabs').find('.tab-content > div').hide();
    $(this).closest('.tabs').find('.tab-content > div').eq($(this).index()).show();
  });
  $('.tabs .tab-head a:first-child').trigger('click');
  $('#main-slideshow .sl').slick({
    infinite:true,
    slidesToScroll:3,
    centerMode:true,
    variableWidth:true,
    arrows:false,
    initialSlide:4,
    autoplay:true,
    autoplaySpeed:7000,
    swipeToSlide:true,
    pauseOnHover:false,
    pauseOnFocus:false,
  });
  $('#f-s .modal__close-button').click(function(){
    $('#f-s').removeClass('active');
  });
  $('.faq .head').click(function(){
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle(250);
  });
  $('.table-content a').click(function(e){
    var t=$(this).attr('href');
    $('body,html').animate({
      scrollTop:$(t).offset().top - 20
    },500);
  });
});